import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    color: "#9b1e26",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function CustomizedAccordions(props) {
  const [expanded, setExpanded] = useState(false);
  const tokenData = useSelector((state) => state.tokens.tokens);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const showTree = (list) => {
    const hideDrop = (title, content) => {
      if (!tokenData.token && title === "Refund of the Scholarship Amount:") {
        content = content.slice(0, -1);
      }
      return content;
    };
    return (
      <div className="tree-div">
        {list?.map((item, index) => {
          return (
            <div className="tree-map-div" key={index}>
              {item.title && (
                <div className="md-desc">
                  {index + 1}. {item.title}
                </div>
              )}
              <div className="tree-submap">
                {hideDrop(item.title, item?.contents)?.map((item2, index2) => {
                  return (
                    <div className="tree-submap-div" key={index2}>
                      <div
                        onClick={() => getDrop(item)}
                        className="instructions"
                      >
                        - {item2}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  const getDrop = (item) => {
    console.log("item", item?.contents[2]?.props?.children[0]);
    if (
      item &&
      item?.contents[2]?.props?.children[0]?.includes("Raise Dropout by")
    ) {
      props.getDrop();
    }
  };
  useEffect(() => {
    if (props.reupload) {
      setExpanded(true);
    }
  }, []);
  return (
    <div className="acc-item">
      <Accordion expanded={expanded} onChange={handleChange("panel1")}>
        {props?.question ? (
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Typography>{props.question}</Typography>
          </AccordionSummary>
        ) : null}
        <AccordionDetails>
          <ul>
            {props?.list &&
            props?.list[0]?.title?.includes("Application Stage Drop-out")
              ? showTree(props?.list)
              : props?.list?.map((item, index) => {
                  return (
                    <li key={index}>
                      <Typography
                        onClick={() => getDrop(item)}
                        className="subTitle"
                      >
                        {item}
                      </Typography>
                    </li>
                  );
                })}
          </ul>
        </AccordionDetails>
        {props.children}
      </Accordion>
    </div>
  );
}
